/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Avatar_Dialogdescription1Inputs */

const id_profile_avatar_dialogdescription1 = /** @type {(inputs: Profile_Avatar_Dialogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unggah gambar profil baru.`)
};

const ms_profile_avatar_dialogdescription1 = /** @type {(inputs: Profile_Avatar_Dialogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muat naik imej profil baharu.`)
};

const da_profile_avatar_dialogdescription1 = /** @type {(inputs: Profile_Avatar_Dialogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload et nyt profilbillede.`)
};

const de_profile_avatar_dialogdescription1 = /** @type {(inputs: Profile_Avatar_Dialogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laden Sie ein neues Profilbild hoch.`)
};

const en_us2_profile_avatar_dialogdescription1 = /** @type {(inputs: Profile_Avatar_Dialogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload a new profile image.`)
};

const es_es2_profile_avatar_dialogdescription1 = /** @type {(inputs: Profile_Avatar_Dialogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sube una nueva imagen de perfil.`)
};

const es_mx2_profile_avatar_dialogdescription1 = /** @type {(inputs: Profile_Avatar_Dialogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sube una nueva imagen de perfil.`)
};

const fil_profile_avatar_dialogdescription1 = /** @type {(inputs: Profile_Avatar_Dialogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mag-upload ng bagong larawan ng profile.`)
};

const fr_profile_avatar_dialogdescription1 = /** @type {(inputs: Profile_Avatar_Dialogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Téléversez une nouvelle image de profil.`)
};

const it_profile_avatar_dialogdescription1 = /** @type {(inputs: Profile_Avatar_Dialogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carica una nuova immagine del profilo.`)
};

const hu_profile_avatar_dialogdescription1 = /** @type {(inputs: Profile_Avatar_Dialogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tölts fel egy új profilkép.`)
};

const nl_profile_avatar_dialogdescription1 = /** @type {(inputs: Profile_Avatar_Dialogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload een nieuwe profielfoto.`)
};

const no_profile_avatar_dialogdescription1 = /** @type {(inputs: Profile_Avatar_Dialogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last opp et nytt profilbilde.`)
};

const pl_profile_avatar_dialogdescription1 = /** @type {(inputs: Profile_Avatar_Dialogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prześlij nowy obraz profilowy.`)
};

const pt_br2_profile_avatar_dialogdescription1 = /** @type {(inputs: Profile_Avatar_Dialogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregue uma nova imagem de perfil.`)
};

const pt_profile_avatar_dialogdescription1 = /** @type {(inputs: Profile_Avatar_Dialogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregue uma nova imagem de perfil.`)
};

const ro_profile_avatar_dialogdescription1 = /** @type {(inputs: Profile_Avatar_Dialogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Încarcă o nouă imagine de profil.`)
};

const fi_profile_avatar_dialogdescription1 = /** @type {(inputs: Profile_Avatar_Dialogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lataa uusi profiilikuva.`)
};

const sv_profile_avatar_dialogdescription1 = /** @type {(inputs: Profile_Avatar_Dialogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ladda upp en ny profilbild.`)
};

const vi_profile_avatar_dialogdescription1 = /** @type {(inputs: Profile_Avatar_Dialogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tải lên hình ảnh hồ sơ mới.`)
};

const tr_profile_avatar_dialogdescription1 = /** @type {(inputs: Profile_Avatar_Dialogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yeni bir profil görseli yükleyin.`)
};

const cs_profile_avatar_dialogdescription1 = /** @type {(inputs: Profile_Avatar_Dialogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nahrajte nový profilový obrázek.`)
};

const bg_profile_avatar_dialogdescription1 = /** @type {(inputs: Profile_Avatar_Dialogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Качете нова профилна снимка.`)
};

const ru_profile_avatar_dialogdescription1 = /** @type {(inputs: Profile_Avatar_Dialogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузите новое изображение профиля.`)
};

const uk_profile_avatar_dialogdescription1 = /** @type {(inputs: Profile_Avatar_Dialogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завантажте нове зображення профілю.`)
};

const ar_profile_avatar_dialogdescription1 = /** @type {(inputs: Profile_Avatar_Dialogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تحميل صورة ملف شخصي جديدة.`)
};

const hi_profile_avatar_dialogdescription1 = /** @type {(inputs: Profile_Avatar_Dialogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक नई प्रोफ़ाइल छवि अपलोड करें।`)
};

const th_profile_avatar_dialogdescription1 = /** @type {(inputs: Profile_Avatar_Dialogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อัปโหลดรูปโปรไฟล์ใหม่`)
};

const ja_profile_avatar_dialogdescription1 = /** @type {(inputs: Profile_Avatar_Dialogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいプロフィール画像をアップロード。`)
};

const zh_cn2_profile_avatar_dialogdescription1 = /** @type {(inputs: Profile_Avatar_Dialogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上传新的个人资料图片。`)
};

const zh_hant1_profile_avatar_dialogdescription1 = /** @type {(inputs: Profile_Avatar_Dialogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上傳新的個人資料圖片。`)
};

const ko_profile_avatar_dialogdescription1 = /** @type {(inputs: Profile_Avatar_Dialogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`새 프로필 이미지를 업로드하세요.`)
};

/**
* | output |
* | --- |
* | "Upload a new profile image." |
*
* @param {Profile_Avatar_Dialogdescription1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_avatar_dialogdescription1 = /** @type {((inputs?: Profile_Avatar_Dialogdescription1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Avatar_Dialogdescription1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_avatar_dialogdescription1(inputs)
	if (locale === "ms") return ms_profile_avatar_dialogdescription1(inputs)
	if (locale === "da") return da_profile_avatar_dialogdescription1(inputs)
	if (locale === "de") return de_profile_avatar_dialogdescription1(inputs)
	if (locale === "en-US") return en_us2_profile_avatar_dialogdescription1(inputs)
	if (locale === "es-ES") return es_es2_profile_avatar_dialogdescription1(inputs)
	if (locale === "es-MX") return es_mx2_profile_avatar_dialogdescription1(inputs)
	if (locale === "fil") return fil_profile_avatar_dialogdescription1(inputs)
	if (locale === "fr") return fr_profile_avatar_dialogdescription1(inputs)
	if (locale === "it") return it_profile_avatar_dialogdescription1(inputs)
	if (locale === "hu") return hu_profile_avatar_dialogdescription1(inputs)
	if (locale === "nl") return nl_profile_avatar_dialogdescription1(inputs)
	if (locale === "no") return no_profile_avatar_dialogdescription1(inputs)
	if (locale === "pl") return pl_profile_avatar_dialogdescription1(inputs)
	if (locale === "pt-BR") return pt_br2_profile_avatar_dialogdescription1(inputs)
	if (locale === "pt") return pt_profile_avatar_dialogdescription1(inputs)
	if (locale === "ro") return ro_profile_avatar_dialogdescription1(inputs)
	if (locale === "fi") return fi_profile_avatar_dialogdescription1(inputs)
	if (locale === "sv") return sv_profile_avatar_dialogdescription1(inputs)
	if (locale === "vi") return vi_profile_avatar_dialogdescription1(inputs)
	if (locale === "tr") return tr_profile_avatar_dialogdescription1(inputs)
	if (locale === "cs") return cs_profile_avatar_dialogdescription1(inputs)
	if (locale === "bg") return bg_profile_avatar_dialogdescription1(inputs)
	if (locale === "ru") return ru_profile_avatar_dialogdescription1(inputs)
	if (locale === "uk") return uk_profile_avatar_dialogdescription1(inputs)
	if (locale === "ar") return ar_profile_avatar_dialogdescription1(inputs)
	if (locale === "hi") return hi_profile_avatar_dialogdescription1(inputs)
	if (locale === "th") return th_profile_avatar_dialogdescription1(inputs)
	if (locale === "ja") return ja_profile_avatar_dialogdescription1(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_avatar_dialogdescription1(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_avatar_dialogdescription1(inputs)
	return ko_profile_avatar_dialogdescription1(inputs)
});
export { profile_avatar_dialogdescription1 as "profile.avatar.dialogDescription" }